// extracted by mini-css-extract-plugin
export var previewContainer = "_si-0";